<agr-dialog [data]="data" (cancel)="cancel()" (confirm)="confirm()" class="order-details" data-test="order-details">
  <ng-container *ngIf="orderDetails$ | async as orderDetails">
    <p class="spacing--margin-none-bottom" *ngIf="description">
      {{ description }}
    </p>

    <div class="flex flex__column spacing--margin-bottom">
      <div class="flex__child">
        <div class="text--small text--gray spacing--padding-top">
          {{ orderTypePrefixForTranslations + 'order-details.order-finalized' | translate }}
        </div>
        <div data-test="order-details__order-finalized">
          {{ orderDetails.createdOn | agrDate }}
        </div>
      </div>
      <div class="flex__child">
        <div class="text--small text--gray spacing--padding-top">
          {{ 'order-details.order-type' | translate }}
        </div>
        <div data-test="order-details__web-order-number">
          {{ 'app.order-types.' + orderDetails.orderType | lowercase | translate }}
        </div>
      </div>
      <div class="flex__child">
        <div class="text--small text--gray spacing--padding-top">
          {{ 'order-details.amount-of-products' | translate }}
        </div>
        <div data-test="order-details__amount-of-products">
          {{ orderDetails.numberOfProducts }}
        </div>
      </div>
      <div class="flex__child">
        <div class="text--small text--gray spacing--padding-top">
          {{ 'order-details.web-order-number' | translate }}
        </div>
        <div data-test="order-details__web-order-number">
          {{ orderDetails.webOrderNumber }}
        </div>
      </div>
    </div>
    <mat-divider></mat-divider>

    <div>
      <h4>{{ orderTypePrefixForTranslations + 'order-details.ordered-products' | translate }}</h4>

      <div *ngIf="(orderDetails$ | async)?.orderType !== returnableOrderType" class="notification notification-info text--small">
        <mat-icon>info</mat-icon>
        {{ 'app.orders.description-sap' | translate }}
      </div>

      <div class="order-details__table mat-elevation-z1 spacing--margin-vertical spacing--margin-top">
        <agr-table
          *ngIf="tableConfig"
          [emptyTitle]="'app.orders-table.error-messages.empty-title' | translate"
          [emptyDescription]="'app.orders-table.error-messages.empty-description' | translate"
          [config]="tableConfig"
          data-test="orders-table__table"
        >
        </agr-table>
      </div>
    </div>
  </ng-container>

  <ng-template #nameColumn let-row="row">
    <div class="flex--column">
      <span>{{ row.name }}</span>
      <span class="text--label" *ngIf="row.skuDetail?.externalId?.length > 0">
        {{ row.skuDetail.externalId }}
      </span>
    </div>
  </ng-template>

  <ng-template #deliveryDateColumn let-row="row">
    <div class="flex--column" *ngIf="row?.deliveryInformation?.deliveryDate as deliveryDate">
      <span *ngIf="row?.deliveryInformation | formatFlexibilityDate as minimumDate; else noFlexibility">
        {{ minimumDate }} - {{ deliveryDate | agrDate }}
      </span>
      <ng-template #noFlexibility>
        {{ deliveryDate | agrDate }}
      </ng-template>
    </div>
  </ng-template>

  <ng-template #orderQuantityColumn let-row="row">
    <div class="flex--row">
      <span *ngIf="row?.orderQuantity >= 0"> {{ row?.orderQuantity | agrNumber }}&#160;</span>
      <span *ngIf="row?.orderUnit">
        {{ 'unit.' + row.orderUnit | translate }}
      </span>
    </div>
  </ng-template>

  <ng-template #externalInvoiceIdColumn let-row="row">
    <div>
      <p class="spacing--margin-none-vertical">
        <span>{{ row.externalInvoiceId }}</span>
      </p>
    </div>
  </ng-template>

  <ng-template #silosColumn let-row="row">
    <div *ngIf="row.silos?.length > 0">
      <p class="spacing--margin-none-vertical">
        <span>{{ 'order-details.products.silo-label' | translate }}&#160;</span>
        <span>{{ row.silosLabel }}</span>
      </p>
    </div>
  </ng-template>

  <ng-template #supplementsColumn let-row="row">
    <div *ngIf="row.productSupplements?.length > 0">
      <ol class="spacing--padding-left">
        <ng-container *ngFor="let productSupplement of row.productSupplements">
          <li>{{ productSupplement.description + ' - ' + productSupplement.quantity }}</li>
        </ng-container>
      </ol>
    </div>
  </ng-template>
</agr-dialog>
